import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ClassDto } from '@proxy/classes';
import { CourseClassesService } from '@proxy/courses';

@Component({
  selector: 'app-courses-video-player',
  templateUrl: './courses-video-player.component.html',
  styleUrls: ['./courses-video-player.component.scss']
})
export class CoursesVideoPlayerComponent implements OnInit, OnChanges {
  @Input() class: ClassDto;
  @Input() fileStreamSource: string;
  @Input() tenantCourseId: string;
  @Output() classReviewed = new EventEmitter<void>();
  isLoading: boolean = false;
  private hasVideoEnded: boolean = false;

  constructor(private classesService: CourseClassesService) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['class'] && !changes['class'].firstChange) {
      this.hasVideoEnded = false;
    }
  }

  onVideoEnded() {
    if (!this.hasVideoEnded && this.tenantCourseId) {
      this.hasVideoEnded = true;
      this.classesService.markAsReviewed(this.class.id, this.tenantCourseId).subscribe({
        complete: () => this.classReviewed.emit()
      });
    }
  }
}
